<template>
  <!--  <div class="card">-->
  <div>
    <div v-if="companyDeployTabs">
      <div class="text-center py-1 text-white nav-style fw-bold text-uppercase">
        {{ $store.getters.getSingleCompanyData.name }}
      </div>
      <ul
        class="nav nav-tabs justify-content-center nav-style"
        id="myTab"
        role="tablist"
      >
        <li
          v-for="(tab, index) in companyDeployTabs"
          :key="index"
          class="nav-item"
          role="presentation"
        >
          <button
            class="nav-link"
            :id="tab.name + '-tab'"
            data-bs-toggle="tab"
            v-bind:class="
              tab.name === activeTab
                ? 'active active-button'
                : 'inactive-button'
            "
            type="button"
            @click="setActive(tab.name)"
            role="tab"
            :aria-controls="tab.path"
            aria-selected="true"
          >
            {{ tab?.title }}
          </button>
        </li>
      </ul>

      <div class="tab-content" id="myTabContent">
        <div
          v-for="(tab, index) in companyDeployTabs"
          :key="index"
          class="tab-pane fade"
          v-bind:class="tab.name === activeTab ? 'show active' : ''"
          :id="tab.path"
          role="tabpanel"
          :aria-labelledby="tab.name + '-tab'"
        ></div>
        <Owner v-if="activeTab === companyDeployTabs.OWNER_URL?.name" />
        <Stoppage v-if="activeTab === companyDeployTabs.STOPPAGE_URL?.name" />
        <Counter v-if="activeTab === companyDeployTabs.COUNTER_URL?.name" />
        <Route v-if="activeTab === companyDeployTabs.ROUTE_URL?.name" />
        <div
          v-if="$store.getters.getSingleCompanyData?.fareType === 'predefined'"
        >
          <SeatFare
            v-if="activeTab === companyDeployTabs.SEAT_FARE_URL?.name"
          />
        </div>
        <SeatClass
          v-if="activeTab === companyDeployTabs.SEAT_CLASS_URL?.name"
        />
        <SeatPlan v-if="activeTab === companyDeployTabs.SEAT_PLAN_URL?.name" />
        <Coach v-if="activeTab === companyDeployTabs.COACH_URL?.name" />
        <Trips v-if="activeTab === companyDeployTabs.TRIPS_URL?.name" />
        <Agent v-if="activeTab === companyDeployTabs.AGENT_URL?.name" />
        <CountermanSeperate
          v-if="activeTab === companyDeployTabs.COUNTERMAN_URL?.name"
        />
        <Supervisor
          v-if="activeTab === companyDeployTabs.SUPERVISOR_URL?.name"
        />
        <Driver v-if="activeTab === companyDeployTabs.DRIVER_URL?.name" />
        <DtRoutes v-if="activeTab === companyDeployTabs.DT_ROUTE_URL?.name" />
<!--        <DtSeatFare v-if="activeTab === companyDeployTabs.DT_FARE_URL?.name" />-->
        <DesignList v-if="activeTab === companyDeployTabs.TICKET_DESIGN_URL?.name" />

      </div>
    </div>
  </div>
</template>

<script>
import web from "@/urls/web";
import Stoppage from "./Children/Stoppage/Stoppage";
import Owner from "./Children/Owner/Owner.vue";
import Route from "./Children/Routes/Routes";
import SeatClass from "./Children/SeatClass/SeatClass";
import SeatPlan from "./Children/SeatPlan/SeatPlan/SeatPlan.vue";
import SeatFare from "./Children/SeatFare/SeatFare/SeatFare.vue";
import { onBeforeMount, onBeforeUnmount, ref, watch } from "vue";
import store from "@/store";
import Counter from "./Children/Counter/Counter";
import Trips from "./Children/Trips/Trips.vue";
import Coach from "./Children/Coach/Coach.vue";
import CountermanSeperate from "./Children/counterman/CountermanSeperate.vue";
import Agent from "@/views/Admin/CompanyDeploy/Children/Agent/Agent.vue";
import Supervisor from "@/views/Admin/CompanyDeploy/Children/Supervisor/Supervisor.vue";
import Driver from "@/views/Admin/CompanyDeploy/Children/Driver/Driver.vue";
import DtRoutes from "@/views/Admin/CompanyDeploy/Children/DtRoutes/DtRoutes";
// import DtSeatFare from "@/views/Admin/CompanyDeploy/Children/DtFare/DtSeatFare";
// import permission from "@/modules/permission";
import roles from "@/modules/roles";
import DesignList from "@/views/Admin/CompanyDeploy/Children/TicketDesign/LayoutList";

// const {hasPermission} = permission();
const { Admin } = roles();

export default {
  name: "CompanyManage",
  components: {
    DesignList,
    Route,
    Owner,
    Stoppage,
    Counter,
    Trips,
    Agent,
    CountermanSeperate,
    SeatClass,
    SeatPlan,
    SeatFare,
    Coach,
    Supervisor,
    Driver,
    DtRoutes,
    // DtSeatFare,
  },
  setup() {
    let companyDeployTabs = ref({
      ...web.Admin.COMPANY_DEPLOY_URL.children.MANAGE_URL.children,
    });
    let activeTab = ref("");
    if (store.getters.getSingleCompanyData?.fareType === "instant_fare") {
      delete companyDeployTabs.value["SEAT_FARE_URL"];
    } else if (store.getters.getSingleCompanyData?.fareType === "trip_fare") {
      delete companyDeployTabs.value["SEAT_FARE_URL"];
    }

    watch(
      () => store.getters.userRoles,
      (value) => {
        if (!value?.includes(Admin.adminRead)) {
          delete companyDeployTabs.value["TRIPS_URL"];
        } else {
          companyDeployTabs.value = {
            ...web.Admin.COMPANY_DEPLOY_URL.children.MANAGE_URL.children,
          };
          if (store.getters.getSingleCompanyData?.fareType === "instant_fare") {
            delete companyDeployTabs.value["SEAT_FARE_URL"];
          } else if (
            store.getters.getSingleCompanyData?.fareType === "trip_fare"
          ) {
            delete companyDeployTabs.value["SEAT_FARE_URL"];
          }
        }
      }
    );

    watch(
      () => store.getters.getSingleCompanyData?.fareType,
      () => {
        companyDeployTabs.value = {
          ...web.Admin.COMPANY_DEPLOY_URL.children.MANAGE_URL.children,
        };
        if (store.getters.getSingleCompanyData?.fareType === "instant_fare") {
          delete companyDeployTabs.value["SEAT_FARE_URL"];
        } else if (
          store.getters.getSingleCompanyData?.fareType === "trip_fare"
        ) {
          delete companyDeployTabs.value["SEAT_FARE_URL"];
        }
      }
    );

    const setActive = (index) => {
      activeTab.value = index;
      store.commit("setActiveTab", activeTab.value);
    };

    onBeforeMount(() => {
      activeTab.value = store.getters.getActiveTab
        ? store.getters.getActiveTab
        : companyDeployTabs.value.OWNER_URL.name;
    });
    onBeforeUnmount(() => {
      if (store.getters.isLoggedIn) {
        store.commit("setActiveTab", "");
      }
    });

    return {
      companyDeployTabs,
      activeTab,
      setActive,
    };
  },
};
</script>

<style scoped>
/*.card {*/
/*  padding: 20px 30px;*/
/*}*/

.nav-style {
  background: #3b3b3b;
  border-top: 1px;
}

.active-button {
  background: #242424 !important;
  border: 1px solid #242424 !important;
  color: #fff !important;
}

.inactive-button {
  color: #fff !important;
}
</style>
